/**
 * SystemMessage - Separator for system messages
 * 
 * Displays system events like "User was assigned to this ticket"
 */

interface SystemMessageProps {
  content: string;
  className?: string;
}

export function SystemMessage({ content, className = "" }: SystemMessageProps) {
  return (
    <div className={`flex items-center gap-3 py-3 ${className}`}>
      <div className="flex-1 h-px bg-border" />
      <span className="text-xs text-muted-foreground px-2 text-center max-w-[80%]">
        {content}
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}
